import React from 'react';
import { BUTTON_STYLES } from '../../constants/styles';
import { ValidationWarning } from '../Messages/StatusMessages';

const SauceSubstitutionSection = ({ order, orderIndex, onSauceSubstitution, isLocked, saving }) => {
    if (!order.sauceOptions || order.sauceOptions.length === 0) {
        return null;
    }
    const getActiveSauceCount = () => {
        if (!order.sauceOptions || !Array.isArray(order.sauceOptions) || order.meal === 'Add On' || order.meal === 'Snack') return null;
        return order.sauceOptions.filter(option => option.isActive).length;
    };

    return (
        <div style={{ marginBottom: '15px' }}>
            <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#555'
            }}>
                Sauce:
            </label>
            {getActiveSauceCount() !== null && getActiveSauceCount() !== undefined && getActiveSauceCount() < 1 && (
                <ValidationWarning message="No Sauce Selected" />
            )}
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px'
            }}>
                {order.sauceOptions.map((sauceOption, index) => {
                    const isActive = sauceOption.isActive;
                    const isDisabled = isLocked || saving || isActive;

                    return (
                        <button
                            key={index}
                            onClick={() => {
                                if (!isActive && onSauceSubstitution) {
                                    const currentActiveSauce = order.sauceOptions.find(opt => opt.isActive);
                                    const oldSauceId = currentActiveSauce ? currentActiveSauce.id : null;
                                    onSauceSubstitution(orderIndex, sauceOption.id, oldSauceId);
                                }
                            }}
                            disabled={isDisabled}
                            style={BUTTON_STYLES.substitution(isActive, isDisabled)}
                        >
                            <span style={{
                                marginRight: '4px',
                                fontSize: '12px'
                            }}>
                                {isActive ? '✓' : '+'}
                            </span>
                            {sauceOption.name}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default SauceSubstitutionSection;